import { gql } from '@apollo/client';

/**
 * Query to get a presigned S3 URL for downloading the Excel template
 * Matches backend: getTemplateDownloadUrl: TemplateDownloadUrl!
 */
export const GET_TEMPLATE_DOWNLOAD_URL_QUERY = gql`
  query GetTemplateDownloadUrl {
    getTemplateDownloadUrl {
      url
      filename
    }
  }
`;
